// @ts-nocheck
import React, { useState, useEffect, FC } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import styled, { keyframes } from 'styled-components'
import useLogs from '../../../hooks/useLogs'
import { SupportedChainIdValue } from '../../../constants/networks'
import LogsItem from '../logs/LogItem'

interface LogsProps {
  chainId: number
}

interface Filter {
  token?: string
  status?: string
  executionPlanId?: string
  chainId?: SupportedChainIdValue | number
}

const Logs: FC<LogsProps> = ({ chainId }) => {
  const params = useParams<{ id: string }>()
  const [filters, setFilters] = useState<Filter>({ status: ['executionSucceeded'], chainId })
  const { data, isLoading } = useLogs(params.id, 1, 70, filters, 0)

  const navigate = useNavigate()
  const location = useLocation()

  const updateURL = (newFilters) => {
    const searchParams = new URLSearchParams()
    Object.keys(newFilters).forEach((key) => {
      const value = newFilters[key]
      if (value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(`${key}[]`, String(v)))
        } else {
          searchParams.set(key, String(value))
        }
      } else {
        searchParams.delete(key)
      }
    })
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true })
  }

  useEffect(() => {
    setFilters({ status: ['executionSucceeded'], chainId })
    updateURL({ token: '', status: ['executionSucceeded'], executionPlanId: '', chainId })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainId])

  if (isLoading) return <LoaderBar />

  if (!data) return <EmptyState>No logs available</EmptyState>

  return (
    <TableWrap>
      <Table>
        <thead>
          <tr>
            <Th>Date</Th>
            <Th>Network</Th>
            <Th>Task</Th>
            <Th>Status</Th>
            <Th>Details</Th>
            <Th>Plan ID</Th>
            <Th></Th>
          </tr>
        </thead>
        <tbody>
          {data?.data?.slice(0, 10).map((task, i) => (
            <LogsItem
              key={i}
              item={task}
              index={i + 1}
              width={1200}
              colored={false}
              handleSelectPlanId={() => {}}
            />
          ))}
        </tbody>
      </Table>
    </TableWrap>
  )
}

export default Logs

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`

const LoaderBar = styled.div`
  height: 2px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 2px;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent, rgba(111, 92, 230, 0.5), transparent);
    animation: ${shimmer} 1.4s ease infinite;
  }
`

const TableWrap = styled.div`
  overflow-x: auto;
  max-width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 8px;
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`

const Th = styled.th`
  padding: 10px 12px;
  text-align: left;
  color: #a1a1a1;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
`

const EmptyState = styled.div`
  color: #777;
  font-size: 13px;
  padding: 24px 0;
  text-align: center;
`
